module.exports = __webpack_public_path__ + "static/media/the-pill-first-lithonia-medical-center.e11cfbc8.jpg";